(function () {
  const root = document.documentElement;
  const toggle = document.querySelector('[data-theme-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const darkPreferred = window.matchMedia('(prefers-color-scheme: dark)').matches;
  let theme = darkPreferred ? 'dark' : 'light';
  root.setAttribute('data-theme', theme);

  const icon = (mode) => mode === 'dark'
    ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>'
    : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>';

  if (toggle) {
    toggle.innerHTML = icon(theme);
    toggle.addEventListener('click', () => {
      theme = theme === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', theme);
      toggle.innerHTML = icon(theme);
      toggle.setAttribute('aria-label', `Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`);
    });
  }

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    setTimeout(() => { drawer.hidden = true; }, 180);
  };

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => openDrawer(cartDrawer));
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', () => closeDrawer(cartDrawer));
  });

  const mobileOpen = document.querySelector('[data-mobile-menu-toggle]');
  const mobileClose = document.querySelector('[data-mobile-menu-close]');
  if (mobileOpen) mobileOpen.addEventListener('click', () => openDrawer(mobileDrawer));
  if (mobileClose) mobileClose.addEventListener('click', () => closeDrawer(mobileDrawer));

  document.querySelectorAll('[data-mega-menu]').forEach((item) => {
    const button = item.querySelector('.nav-link-button');
    if (!button) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.nav-link-button[aria-expanded="true"]').forEach((other) => other.setAttribute('aria-expanded', 'false'));
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mega-menu]')) {
      document.querySelectorAll('.nav-link-button[aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
  });
})();
